/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { Either, Left, Right } from 'purify-ts';
import {
  IMediaRepository,
  MediaRepositoryFailure,
  UploadedMedia,
} from '../../../domain/media/i-media-repository';
import { GONE_CODE, IHttpClient } from '../../services/httpClient/interface';
import { ApiResponse } from '../../../util/type';
import { withQuery } from '../util';

@Injectable({
  providedIn: 'root',
})
export class RealMediaRepository implements IMediaRepository {
  private httpClient = inject(IHttpClient);

  public async upload(
    companyPhoneNumber: string,
    file: File
  ): Promise<Either<MediaRepositoryFailure, UploadedMedia>> {
    try {
      const formData = new FormData();
      formData.append('companyPhoneNumber', companyPhoneNumber);
      formData.append('file', file, file.name);

      const { body } = await this.httpClient.postFormData<ApiResponse<UploadedMedia>>(
        '/whatsapp/media',
        formData
      );
      return Right(body.data);
    } catch (error) {
      return Left(
        MediaRepositoryFailure.fromApiError({
          error,
          fallbackMessage: 'Não foi possível enviar o arquivo.',
        })
      );
    }
  }

  public async getMediaObjectUrl(
    companyPhoneNumber: string,
    messageId: string
  ): Promise<Either<MediaRepositoryFailure, string>> {
    try {
      const { body } = await this.httpClient.getBlob(
        withQuery(`/whatsapp/messages/${encodeURIComponent(messageId)}/media`, {
          companyPhoneNumber,
        })
      );

      return Right(URL.createObjectURL(body));
    } catch (error) {
      if ((error as any)?.status === GONE_CODE) {
        return Left(MediaRepositoryFailure.expired());
      }

      return Left(
        MediaRepositoryFailure.fromApiError({
          error,
          fallbackMessage: 'Não foi possível carregar o anexo.',
        })
      );
    }
  }
}
